import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { CoreModule } from '@core';
import { SharedModule } from '@shared';
import { ShellModule } from './shell/shell.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { GoogleTagManagerModule } from 'angular-google-tag-manager';

import { APP_SETTINGS } from './app.settings';
import { environment } from '@env/environment';


@NgModule({
  imports: [
    BrowserModule,
    GoogleTagManagerModule.forRoot({id: environment.gcp.gtm.gtm_id}),
    HttpClientModule,
    TranslateModule.forRoot(),
    BrowserAnimationsModule,
    CoreModule,
    SharedModule,
    ShellModule,
    AppRoutingModule // must be imported as the last module as it contains the fallback route
  ],
  declarations: [AppComponent],
  providers: [
    APP_SETTINGS
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
